<!-- backend/src/components/Cards/CardGostergelerTable.svelte -->
<script>
  import { gostergeList, formulList, formulDell } from '../../Api.svelte';
  import { onMount } from 'svelte';
  import { formullerStore, selectedFormul, isFormulEditing } from "../../stores/stores";
  import { getAuthorizedData } from '../../mw/check';


  export let color = "light";

  let gostergeler = [];
  let formuller = [];

  onMount(async () => {
    gostergeler = await gostergeList();
    formuller = await formulList();
    formuller = await getAuthorizedData(formuller);

    formullerStore.set(formuller);
  });

  formullerStore.subscribe(sformul => {
    formuller = sformul;
  });

  async function deleteFormul(id, g_id) {
    const confirmed = confirm("Bu Formulü silmek istediğinizden emin misiniz? Bu Formülü Sildiğinizde Formüle ait degerler silinecek tir.");
    if (confirmed) {
      await formulDell(id, g_id);
      formuller = formuller.filter(sformul => sformul._id !== id);
      formullerStore.set(formuller);
    }
  }

  function editFormul(sformul) {
    // console.log(sformul);
    selectedFormul.set(sformul);
    isFormulEditing.set(true);
  }
</script>


<div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded {color === 'light' ? 'bg-white' : 'bg-red-800 text-white'}">
  <div class="rounded-t mb-0 px-4 py-3 border-0">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 class="font-semibold text-lg {color === 'light' ? 'text-blueGray-700' : 'text-white'}">
          Formüller
        </h3>
      </div>
    </div>
  </div>
  <div class="block w-full overflow-x-auto">
    <table class="items-center w-full bg-transparent border-collapse">
      <thead>
        <tr>
          <th class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            No
          </th>
          <th class="px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            Gösterge Adı
          </th>
          <th class="w-16 px-6 align-middle border border-solid py-3 text-xs uppercase border-l-0 border-r-0  font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            Formül
          </th>
          <th class="px-6 align-middle lg:w-1/12 border border-solid py-3 text-xs uppercase border-l-0 border-r-0 whitespace-nowrap font-semibold text-left {color === 'light' ? 'bg-blueGray-50 text-blueGray-500 border-blueGray-100' : 'bg-red-700 text-red-200 border-red-600'}">
            Değişkenler
          </th>

          <th>İşlemler</th>
        </tr>
      </thead>
      <tbody>
        {#each formuller as sformul, i}
        <tr class="odd:bg-white odd:dark:bg-gray-200 even:bg-gray-100 even:dark:bg-gray-800">
          <td class="border-t-0 px-6 align-middle border-b text-xs whitespace-nowrap p-4 ">
            {i+1}
          </td>
          <td class="border-t-0 px-6 align-middle border-b text-xs  p-4 ">
            <!-- {getBoyutName(gosterge.boyut_id, boyutlar)} -->
             {gostergeler.find(({ _id }) => _id === sformul.gosterge_id)?.name }
          </td>
          <td class="border-t-0 px-6 align-middle border-b text-xs whitespace-nowrap p-4 ">
            {sformul.formul}
          </td>  
          <td class="border-t-0 px-6 align-middle border-b text-xs whitespace-nowrap p-4 ">
            {sformul.degiskenler}
          </td> 
          <td class="px-6 py-4 min-w-48 text-center whitespace-nowrap text-sm font-medium border-b">
            <button class="text-indigo-600 hover:text-indigo-900" on:click="{() => editFormul(sformul)}">Düzenle</button>
            <button class="ml-2 text-red-600 hover:text-red-900" on:click="{() => deleteFormul(sformul._id, sformul.gosterge_id)}">Sil</button>
          </td>
        </tr>
        {/each}
      </tbody>
    </table>
  </div>
</div>
